// OurValuesSection.jsx
import React, { useState } from "react";
import "./OurValuesSection.css";

import { motion } from "framer-motion";

import Collaboration from "../assets/images/collaboration.png" 

const OurValuesSection = () => {
  const OurValues = [
    {
      id: "collaboration",
      title: "Collaboration",
      description:
        "Collaboration is the process of two or more people or organisations working together to complete a task or achieve a goal.",
      image: Collaboration
    },
    {
      id: "transparency",
      title: "Transparency",
      description:
        "Transparency means being open and honest in our actions and decisions, ensuring clarity and accountability.",
      image: Collaboration
    },
    {
      id: "trust",
      title: "Trust",
      description:
        "Trust is built through consistent reliability, integrity, and mutual respect in all interactions.",
      image: Collaboration
    },
    {
      id: "integrity",
      title: "Integrity",
      description:
        "Integrity means doing the right thing even when no one is watching, guided by strong ethical principles.",
      image: Collaboration
    }
  ];

  const [selectedValue, setSelectedValue] = useState("collaboration");

  return (
    <motion.section
          initial={{ opacity: 0, y: 80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
        >
    <section className="OurValues-section">
      <div className="container">
        <h2 className="section-title-values">Our Values</h2>
        <p className="intro-text">
          We develop theories, methods and platforms for prediction, profiling, visualisation and simulation.
        </p>

        <div className="OurValues-grid">
          {/* 左侧列表 */}
          <div className="OurValues-list">
            {OurValues.map((value) => (
              <button
                key={value.id}
                className={`value-item ${selectedValue === value.id ? "active" : ""}`}
                onClick={() => setSelectedValue(value.id)}
              >
                <span className="dot"></span>
                <span className="title">{value.title}</span>
              </button>
            ))}
          </div>

          <div className="content-area">
            <p className="description">
              {OurValues.find(v => v.id === selectedValue)?.description}
            </p>
            <img
              src={OurValues.find(v => v.id === selectedValue)?.image}
              alt={OurValues.find(v => v.id === selectedValue)?.title}
              className="value-image"
            />
          </div>
        </div>
      </div>
    </section>
    </motion.section>
  );
};

export default OurValuesSection;